document.addEventListener("latte:init", init);

function init () {
    var dragging = false;

    $('body').on('touchmove', function () {
        dragging = true;
    });

    $('body').on('click touchstart', function () {
        dragging = false;
    });

    // click any element except a combo menu item or child
    $(document).on('click touchend', function (e) {
        if (dragging) {
            return;
        }

        if (!$(this).hasClass('.standard-dropdown-wrapper, .standard-dropdown-item')) {
            if ($('.standard-dropdown-container').is(':visible')) {
                $('.standard-dropdown').hide();
            }
        }
    });

    // auto select value //
    if ($('.bar-dropdown-container').length > 0 && $('.bar-dropdown-container').find('.display-name').text().trim() === 'Select a State' && helper.readCookie('barState')) {
        barState = helper.readCookie('barState');
        displayName = $('.standard-dropdown-item[data-cookie-value="' + barState + '"]').attr('data-display-name');
        $('.bar-dropdown-container').find('.display-name').find('span').text(displayName);
    }

    $('.standard-dropdown-wrapper').hover(function () {
        var thisID = $(this).attr('data-id');
        $('#standard-dropdown' + thisID).show();
    },
        function () {
            var thisID = $(this).attr('data-id');
            $('#standard-dropdown' + thisID).hide();
        }
    );

    // click any dropdown item
    $('.standard-dropdown-wrapper').on('click touchend', function (e) {
        if (dragging) {
            return;
        }

        e.preventDefault();
        e.stopImmediatePropagation();

        var menuID = $(this).attr('data-id');
        var selectedMenu = $('#standard-dropdown' + menuID);

        if ($(selectedMenu).is(':visible')) {
            $(selectedMenu).hide();
        } else {
            $(selectedMenu).show();
        }
    });

    // if click on an item in a combo menu
    $('.standard-dropdown-item').on('click touchend', function (e) {
        if (dragging) {
            return;
        }

        e.preventDefault();
        var thisID = $(this).attr('data-id');
        var autoNavigate = $(this).closest('.standard-dropdown-wrapper').attr('data-auto-navigate');
        var setState = $(this).closest('.standard-dropdown-wrapper').attr('data-set-state');
        var productCompare = $(this).closest('.standard-dropdown-wrapper').attr('data-product-compare');

        // shared functions
        //update name in box
        $('#display-name' + thisID).html($(this).html());

        //update href
        $('#standard-dropdown-button' + thisID).attr('href', $(this).attr('data-href'));

        // product-compare slice with combo label
        $('#standard-dropdown-button' + thisID).text($(this).attr('data-label'));
        $('#standard-dropdown-button' + thisID).attr('data-promo', $(this).attr('data-promo'));

        //product filter
        var sort = $(this).closest('.standard-dropdown-wrapper').attr('data-sort');
        if (sort) {
            var dropdownID = $(this).data('item-id');

            if (dropdownID === 0) {
                $(function () {
                    $(".product").sort(sort_popular).appendTo('.product-container');
                    function sort_popular (a, b) {
                        return ($(b).data('popularity')) < ($(a).data('popularity')) ? 1 : -1;
                    }
                });

            } else if (dropdownID === 1) {
                $(function () {
                    $(".product").sort(sort_price).appendTo('.product-container');
                    function sort_price (a, b) {
                        return ($(b).data('price')) < ($(a).data('price')) ? 1 : -1;
                    }
                });

            } else if (dropdownID === 2) {
                $(function () {
                    $(".product").sort(sort_price).appendTo('.product-container');
                    function sort_price (a, b) {
                        return ($(b).data('price')) > ($(a).data('price')) ? 1 : -1;
                    }
                });
            }
        }
        //end product filter

        // For BAR - only if set state
        if (setState) {
            helper.createCookie('barState', $(this).attr('data-item-id').replace(/ /g, '-'), { expires: 365 });
        }

        // only if auto navigate
        if (autoNavigate === 'true') {
            thisHref = $(this).attr('data-href');
            if (thisHref !== "#") {
                window.loadUrl(thisHref);
            }
        }

        // only if product compare
        if (productCompare) {
            // update price
            $("#starting-at-price" + thisID + " .sale-price").text($(this).attr('data-price'));

            //update strike thought
            $("#starting-at-price" + thisID + " .list-price-strike").text($(this).attr('data-fullPrice'));

            // update affirm data-amount attribute
            $("#affirm-msg" + thisID + " .affirm-as-low-as").attr('data-amount', $(this).attr('affirm-price'));
            if(window && window.affirm && window.affirm.ui) window.affirm.ui.refresh();

            //update details
            $("#combo" + thisID + " .combo-details").hide();
            $("#combo-details-" + $(this).attr('data-item-id')).show();

            //update promo
            $(".promo" + thisID).text($(this).attr('data-promo'));

            //update message after price
            $("#after-price-msg" + thisID).text($(this).attr('data-after-priceMsg'));
        }
    });

    // keyboard accessibility
    $('.standard-dropdown-wrapper').on('keydown', function (e) {
        var menuID = $(this).attr('data-id');
        var selectedMenu = $('#standard-dropdown' + menuID);

        // handle down arrow key
        if (e.which == 40) {
            e.preventDefault();
            $(selectedMenu).show();
            if ($('#standard-dropdown' + menuID + ' .standard-dropdown-item:focus').length === 0) {
                $('#standard-dropdown' + menuID + ' .standard-dropdown-item').first().focus();
            } else {
                $('#standard-dropdown' + menuID + ' .standard-dropdown-item:focus').next().focus();
            }
        }

        // handle up arrow key
        if (e.which == 38) {
            e.preventDefault();
            $('.standard-dropdown-item:focus').prev().focus();
        }

        // handle enter key
        if (e.which == 13) {
            $('.standard-dropdown-item:focus').click();
        }

        // handle tab
        if (e.which == 9) {
            $(selectedMenu).hide();
        }
    });
}



//////////////////
// WEBPACK FOOTER
// ./public/js/standard-dropdown.js
// module id = 90
// module chunks = 0